class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimeout = null;

    this.addEventListener('mouseenter', this.openOnHover.bind(this));
    this.addEventListener('mouseleave', this.closeOnHoverOut.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this), true);
  }

  isDesktopMenu() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  openOnHover() {
    if (!this.isDesktopMenu()) return;

    window.clearTimeout(this.closeTimeout);
    this.closeSiblingMenus();
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  closeSiblingMenus() {
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this || typeof menu.close !== 'function') return;

      window.clearTimeout(menu.closeTimeout);
      menu.close();
    });
  }

  closeOnHoverOut() {
    if (!this.isDesktopMenu()) return;

    this.closeTimeout = window.setTimeout(() => this.close(), 150);
  }

  onSummaryClick(event) {
    if (!this.isDesktopMenu()) return;

    const url = this.mainDetailsToggle.dataset.headerMenuUrl;
    if (!url) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = url;
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
